"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingBody = exports.ONBOARDING_IMAGE_VERTICAL_ALIGN = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
const StackView_1 = require("../StackView");
const FontCSS = (0, styled_components_1.css) `
    font-family: ${helpers_1.BASE_FONT_FAMILY};
    color: ${({ theme }) => theme.colorTextMain};
`;
const Header = styled_components_1.default.div `
    font-size: ${helpers_1.FONT_SIZE_XL};
    font-weight: ${helpers_1.BASE_FONT_BOLD_WEIGHT};
    line-height: 24px;
    min-height: 52px;
    max-width: 260px;
    ${FontCSS}
`;
const ContentWrapper = styled_components_1.default.div `
    padding-top: 40px;
    font-size: ${helpers_1.FONT_SIZE_L};
    font-weight: ${helpers_1.BASE_FONT_NORMAL_WEIGHT};
    line-height: ${helpers_1.FONT_LINE_HEIGHT_L};
    ${FontCSS}
`;
const Image = styled_components_1.default.i `
    display: flex;
    overflow: hidden;
    background-color: transparent;
    background-image: ${({ src }) => (typeof src === 'string' ? `url(${src})` : '')};
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
`;
var ONBOARDING_IMAGE_VERTICAL_ALIGN;
(function (ONBOARDING_IMAGE_VERTICAL_ALIGN) {
    ONBOARDING_IMAGE_VERTICAL_ALIGN["top"] = "top";
    ONBOARDING_IMAGE_VERTICAL_ALIGN["center"] = "center";
    ONBOARDING_IMAGE_VERTICAL_ALIGN["bottom"] = "bottom";
})(ONBOARDING_IMAGE_VERTICAL_ALIGN = exports.ONBOARDING_IMAGE_VERTICAL_ALIGN || (exports.ONBOARDING_IMAGE_VERTICAL_ALIGN = {}));
const VERTICAL_ALIGNS_VALUES = {
    [ONBOARDING_IMAGE_VERTICAL_ALIGN.top]: 'flex-start',
    [ONBOARDING_IMAGE_VERTICAL_ALIGN.center]: 'center',
    [ONBOARDING_IMAGE_VERTICAL_ALIGN.bottom]: 'flex-end'
};
const ImageWrapper = styled_components_1.default.div `
    display: flex;
    align-items: ${({ verticalAlign }) => VERTICAL_ALIGNS_VALUES[verticalAlign]};

    ${Image} {
        width: 300px;
        height: 300px;
        min-height: 300px;
        min-width: 300px;
    }
`;
const Dot = styled_components_1.default.div `
    height: ${helpers_1.SPACING_S};
    width: ${helpers_1.SPACING_S};
    box-sizing: border-box;
    border-radius: ${helpers_1.SPACING_S};

    ${({ isCurrent, theme }) => (0, styled_components_1.css) `
        background-color: ${isCurrent ? theme.colorButtonRest : 'transparent'};
        border: ${helpers_1.BASE_BORDER_WIDTH} solid ${theme.colorControlBorderAccent};
    `}
`;
const StepsWrapper = (0, styled_components_1.default)(StackView_1.StackView) `
    padding-top: ${helpers_1.SPACING_M};
`;
const Wrapper = (0, styled_components_1.default)(StackView_1.StackView) `
    padding: 0 ${helpers_1.SPACING_M};
`;
exports.OnboardingBody = (0, helpers_1.createUIElement)('OnboardingBody', (_a, ref) => {
    var { className, header, content, image, imageVerticalAlign = ONBOARDING_IMAGE_VERTICAL_ALIGN.top, totalSteps = 0, currentIndex, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "header", "content", "image", "imageVerticalAlign", "totalSteps", "currentIndex", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    if (totalSteps < 0) {
        throw new Error("'TotalSteps' must not be less than zero in 'OnboardingBody'");
    }
    if (currentIndex && currentIndex + 1 > totalSteps) {
        throw new Error("'CurrentIndex' must be less than or equal to 'totalSteps' - 1 in 'OnboardingBody'");
    }
    const dataSelectorId = rest['data-selector-id'] || 'onboarding-body';
    return (react_1.default.createElement(Wrapper, Object.assign({}, rest, { "data-selector-id": dataSelectorId, className: `vm-OnboardingBody ${className}`, direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(Header, null, header),
        react_1.default.createElement(StackView_1.StackView, { gap: StackView_1.STACK_GAP.m, distribution: StackView_1.STACK_DISTRIBUTION.firstFill },
            react_1.default.createElement(ContentWrapper, null, content),
            react_1.default.createElement(ImageWrapper, { verticalAlign: imageVerticalAlign }, typeof image === 'string' ? (react_1.default.createElement(Image, { src: image })) : (react_1.default.isValidElement(image) && image))),
        react_1.default.createElement(StepsWrapper, { align: StackView_1.STACK_ALIGN.start, gap: StackView_1.STACK_GAP.s, distribution: StackView_1.STACK_DISTRIBUTION.center }, [...Array(totalSteps)].map((x, idx) => {
            const isCurrent = idx === currentIndex;
            return (react_1.default.createElement(Dot, { "data-selector-id": `${dataSelectorId}-dot-${idx}`, key: `dot-${idx}`, isCurrent: isCurrent, "data-current": isCurrent ? true : undefined }));
        }))));
});
//# sourceMappingURL=OnboardingBody.js.map